// Greybox tileset — placeholder colored tiles GENERATED AT RUNTIME (no PNG, no Tiled).
// Chaque "kind" = une couleur unie de 16×16 px. Sert de blockout du campus en attendant que
// Maxence peigne les vraies cartes dans Tiled. Index de tuile = position dans GREYBOX_PALETTE.
import 'phaser'

export const TILE_SIZE = 16
export const GREYBOX_TEXTURE_KEY = 'greybox-tiles'

export interface TileKind {
    /** caractère utilisé dans les cartes ASCII */
    char: string
    /** couleur 0xRRGGBB */
    color: number
    /** true => mur : GridEngine bloque (via propriété ge_collide posée à la volée) */
    solid: boolean
    /** libellé lisible (debug) */
    label: string
}

// L'ORDRE compte : l'index dans ce tableau est l'index de tuile utilisé par putTileAt.
export const GREYBOX_PALETTE: TileKind[] = [
    { char: '.', color: 0x6c8f4a, solid: false, label: 'grass' },     // 0 herbe / espaces verts
    { char: ',', color: 0x9aa0a6, solid: false, label: 'concrete' },  // 1 béton (cour, allées)
    { char: '_', color: 0xcdbb96, solid: false, label: 'floor' },     // 2 sol intérieur
    { char: '#', color: 0x3c4048, solid: true,  label: 'wall' },      // 3 mur (collision)
    { char: 'D', color: 0xb5651d, solid: false, label: 'door' },      // 4 porte (marchable, gérée par Door)
    { char: 'T', color: 0x2f6b34, solid: true,  label: 'tree' },      // 5 arbre / obstacle
    { char: 'C', color: 0x8a6d3b, solid: false, label: 'court' },     // 6 terrain de sport
    { char: 'W', color: 0x3b6ea5, solid: true,  label: 'blocked' },   // 7 zone bloquée (eau/clôture)
]

const DEFAULT_CHAR = '.'

/** char -> index de tuile (avec repli sur l'herbe). */
export function charToIndex(): Record<string, number> {
    const map: Record<string, number> = {}
    GREYBOX_PALETTE.forEach((kind, i) => { map[kind.char] = i })
    return map
}

/** Indices des tuiles solides (murs) -> reçoivent ge_collide. */
export function solidIndices(): Set<number> {
    return new Set(GREYBOX_PALETTE.flatMap((k, i) => (k.solid ? [i] : [])))
}

export function indexForChar(char: string): number {
    const map = charToIndex()
    return map[char] ?? map[DEFAULT_CHAR]
}

/**
 * Génère (une seule fois) la texture du tileset greybox : une bande horizontale de N tuiles
 * 16×16, une couleur par kind. Guard sur textures.exists pour être partagée par toutes les scènes
 * et survivre à scene.restart() (le TextureManager est global).
 */
export function ensureGreyboxTexture(scene: Phaser.Scene): void {
    if (scene.textures.exists(GREYBOX_TEXTURE_KEY)) return

    const n = GREYBOX_PALETTE.length
    const canvasTexture = scene.textures.createCanvas(GREYBOX_TEXTURE_KEY, n * TILE_SIZE, TILE_SIZE)
    if (!canvasTexture) return
    const ctx = canvasTexture.getContext()

    GREYBOX_PALETTE.forEach((kind, i) => {
        const x = i * TILE_SIZE
        ctx.fillStyle = '#' + kind.color.toString(16).padStart(6, '0')
        ctx.fillRect(x, 0, TILE_SIZE, TILE_SIZE)
        // liseré pour lire la grille en mode greybox
        ctx.strokeStyle = 'rgba(0,0,0,0.22)'
        ctx.lineWidth = 1
        ctx.strokeRect(x + 0.5, 0.5, TILE_SIZE - 1, TILE_SIZE - 1)
    })

    canvasTexture.refresh() // pousse les pixels du canvas vers la texture GPU
}
